import React from 'react';

export interface IconWarningProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconWarning: React.FC<IconWarningProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <g clipPath="url(#clip0_29_1604)"> <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeMiterlimit="10" /> <path d="M12 7.5V12.75" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" /> <rect x="11" y="15" width="2" height="2" fill={fill || "#020617"} /> </g> <defs> <clipPath id="clip0_29_1604"> <rect width="24" height="24" fill={fill || "white"} /> </clipPath> </defs>  
    </svg>
  );
};

export default IconWarning;
